import { LayoutColors } from '@src/core/theme';
import styled from 'styled-components';
import useTranslate, { DefaultMessagesKeys } from '@src/i18n/useTranslate';
import WarningIcon from '@src/icons/warning-triangle-icon.svg';
import {
  BodyLarge,
  BodyRegular,
  BodyRegularMedium,
  BodyRegularSemiBold,
  BodySmall,
  Heading6,
} from '@src/fonts/typography/Typography';
import { useAppDispatch } from '@src/core/hooks';
import React from 'react';
import { clearPaymentErrors } from '@src/features/payments/store/payment';
import { device } from '@src/common/breakpoints';

interface DisapprovedPurchaseModalProps {
  descriptions?: string[];
}

export const DisapprovedPurchaseModal = ({ descriptions }: DisapprovedPurchaseModalProps) => {
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();

  return (
    <DisapprovedPurchaseContainer>
      <Content>
        <Title>{i18n('checkout_disapproved_warning')}</Title>
        <WarningIcon />
        <DisapprovedIntro>{i18n('checkout_disapproved_intro')}</DisapprovedIntro>
        {descriptions ? (
          <DisapprovedDescription>{i18n(descriptions[0] as DefaultMessagesKeys)}</DisapprovedDescription>
        ) : null}
        <Retry onClick={() => dispatch(clearPaymentErrors())}>{i18n('checkout_disapproved_try_again')}</Retry>
      </Content>
    </DisapprovedPurchaseContainer>
  );
};

const DisapprovedPurchaseContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Content = styled.div`
  width: 343px;
  border-radius: 8px;
  background-color: ${LayoutColors.whiteLight};
  padding: 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 16px;
  margin: auto;

  ${device.mediumTablet} {
    width: 552px;
    padding: 32px;
    gap: 24px;
  }

  @media (max-width: 350px) {
    width: 300px;
  }

  @media (max-width: 310px) {
    width: 270px;
  }
`;

const Title = styled.h6`
  ${Heading6};
  color: ${LayoutColors.warningDark};
`;

const DisapprovedIntro = styled.p`
  ${BodyRegularMedium};

  ${device.mediumTablet} {
    ${BodyLarge};
  }
  margin-top: 12px;
`;

const DisapprovedDescription = styled.p`
  ${BodySmall};

  ${device.mediumTablet} {
    ${BodyRegular};
  }
  text-align: center;
`;

const Retry = styled.button`
  width: 100%;
  background-color: ${LayoutColors.successDark};
  height: 44px;
  ${BodyRegularSemiBold};
  border-radius: 4px;
  padding: 8px;
  color: ${LayoutColors.whiteLight};
  cursor: pointer;
  border: none;
  border-style: none;
`;
